import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import esMX from "./es-MX.json";

/**
 * `es-MX` is the only locale, and the default (D18: identifiers in English,
 * everything a seller reads in Spanish). i18next is here so that user-facing
 * strings live in one file from the start — retrofitting it across a built
 * inbox is the expensive way to do this.
 */
void i18n.use(initReactI18next).init({
  resources: { "es-MX": { translation: esMX } },
  lng: "es-MX",
  fallbackLng: "es-MX",
  interpolation: { escapeValue: false },
});

export default i18n;

/**
 * `t` for code that runs outside React.
 *
 * Query functions, the Twilio device wrapper and anything else off the render
 * path cannot call `useTranslation`, but the strings they produce are read by
 * a seller just the same. `init` above is synchronous, so this is usable the
 * moment the module is imported.
 */
export const t = i18n.t.bind(i18n);
